import axios from "axios";

export default async function() {
  const response = await axios.get(process.env.VUE_APP_CHECK_STATUS);
  if (response.data.auth === 1) {
    return response.data.log;
  } else {
    return false;
  }
}
